import React, { Component } from 'react';
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Time from "../../utils/Time";
import {RESERVATION_CHECKOUT_TIMEOUT_DURATION} from "../../constants/GeneralConstants";
import Countdown from 'react-countdown';
import Money from "../../utils/Money";


export default class PendingReservationsTableView extends Component {

    static propTypes = {
        reservations: PropTypes.arrayOf(PropTypes.shape({
            reservationRequestId: PropTypes.number.isRequired,
            advertisementId: PropTypes.number.isRequired,
            advertisementTitle: PropTypes.string.isRequired,
            spaceId: PropTypes.number.isRequired,
            spaceTitle: PropTypes.string.isRequired,
            statusId: PropTypes.number.isRequired,
            statusName: PropTypes.string.isRequired,
            startDate: PropTypes.string.isRequired,
            endDate: PropTypes.string.isRequired,
            created: PropTypes.number.isRequired,
            updated: PropTypes.number.isRequired,
            deleted: PropTypes.bool.isRequired,
            pricePerDay: PropTypes.number.isRequired,
            hasOverLappingRequests: PropTypes.bool.isRequired,
        }))
    };

    render() {
        if (this.props.reservations.length === 0) {
            return (
                <div className="text-muted text-center mt-5 mb-5">
                    You currently have no Reservation Requests.
                    <br/>
                    Search for spaces that you think would be
                    <br/>
                    a good fit for your Advertisements,
                    <br/>
                    and request a reservation with them.
                </div>
            );
        }

        return (
            <React.Fragment>
                <div className="d-flex align-content-stretch flex-wrap">
                    {
                        this.props.reservations.map((reservation) => {
                            return (
                                <div className="col-xs-12 col-md-6 col-lg-4 pt-2" key={"Reservation-"+reservation.reservationRequestId}>
                                    <div className="card rounded h-100">
                                        <div className="card-header text-center">
                                            Reservation Request
                                        </div>
                                        <div className="card-body border-top-box pb-1" id={reservation.reservationRequestId}>
                                            <div className="row">
                                                <div className="col-6 border-right">
                                                    <div className="row m-0">
                                                        <h5 className="m-auto">
                                                            Ad
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-1 mb-2"/>
                                                    <div className="row m-0">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link pl-0 pr-0 m-auto"
                                                            onClick={(e) => this.handleAdvertisementClicked(reservation.advertisementId)}
                                                        >
                                                            <h6 className="card-title bold-contents-text">
                                                                {reservation.advertisementTitle}
                                                            </h6>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="row m-0">
                                                        <h5 className="m-auto">
                                                            Space
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-1 mb-2"/>
                                                    <div className="row m-0">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link pl-0 pr-0 m-auto"
                                                            onClick={(e) => this.handleSpaceClicked(reservation.spaceId)}
                                                        >
                                                            <h6 className="card-title bold-contents-text">
                                                                {reservation.spaceTitle}
                                                            </h6>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-12">
                                                    <div className="row justify-content-center">
                                                        <h5>
                                                            Date Range
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-0 mb-2"/>
                                                    <div className="row justify-content-center">
                                                        {this._convertTimestampToStartAndEndString(reservation.startDate, reservation.endDate)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-12">
                                                    <div className="row justify-content-center">
                                                        <h5>
                                                            Total Value
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-0 mb-2"/>
                                                    <div className="row justify-content-center">
                                                        {this._calculatePrice(reservation.pricePerDay, reservation.startDate, reservation.endDate)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer p-0">
                                            <div className="row m-0">
                                                {this._renderCheckoutButton(reservation)}
                                            </div>
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    {this._renderCountDown(reservation)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </React.Fragment>
        );
    }

    _renderCheckoutButton(reservation) {
        if(reservation.statusName === "PENDING_PAYMENT") {
            return (
                <div className="col-12 text-center p-0">
                    <button
                        type="button"
                        className="btn btn-success w-100"
                        onClick={(e) => this.handleCheckoutButtonClicked(reservation.reservationRequestId)}
                    >
                        <i className="fas fa-credit-card mr-1" />
                        Check Out
                    </button>
                </div>
            );
        }
        return (
            <div className="col-12 text-center text-warning">
                <strong>Pending Acceptance</strong>
            </div>
        );
    }

    _renderCountDown(reservation) {
        if(reservation.statusName === "PENDING_PAYMENT") {
            return (
                <Countdown
                    date={Time.addTimeToDuration(new Date(reservation.created * 1000), RESERVATION_CHECKOUT_TIMEOUT_DURATION)}
                    renderer={this._countDownRender}
                />
            );
        }
        return null;
    }

    _countDownRender({days, hours, minutes, seconds, completed }) {
        if (completed) {
            return (<strong className="text-danger">Time Expired</strong>);
        } else {
            const hoursIncludingDays = (days*24) + hours;
            if (hoursIncludingDays < 12) {
                if (hoursIncludingDays < 1) {
                    return (<span className="text-danger">{hoursIncludingDays}:{minutes}:{seconds}</span>);
                }
                return (<span className="text-warning">{hoursIncludingDays}:{minutes}:{seconds}</span>);
            }
            return (<span>{hoursIncludingDays}:{minutes}:{seconds}</span>);
        }
    }

    handleSpaceClicked = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.RESERVATION_REQUESTS_SPACE_BUTTON_CLICKED, {spaceId: spaceId});
    };

    handleAdvertisementClicked = (advertisementId) => {
        EventPublisher.publish(UIInteractionEvents.RESERVATION_REQUESTS_ADVERTISEMENT_BUTTON_CLICKED, {advertisementId: advertisementId});
    };

    handleCheckoutButtonClicked = (reservationRequestId) => {
        EventPublisher.publish(UIInteractionEvents.PENDING_RESERVATIONS_CHECKOUT_BUTTON_CLICKED, {reservationRequestId: reservationRequestId});
    };

    _convertTimestampToStartAndEndString(start, end) {
        return Time.parseDate(start).toLocaleDateString() + " to " + Time.parseDate(end).toLocaleDateString();
    }

    _calculatePrice(pricePerDay, startDate, endDate) {
        const numberOfDaysInReservation = Time.calculateDifferenceInDaysBetweenInclusive(Time.parseDate(startDate), Time.parseDate(endDate));
        return Money.formatMoney(pricePerDay * numberOfDaysInReservation);
    }
}